export default __webpack_public_path__ + "static/boots.en.cover-cf3ff365d1e7a48b0daaf0c965d5280a.jpg";